import { Component, Injector, OnInit, inject } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import {
  jkLib,
  jkRestReturn,
  UiModeType,
} from 'jk-service';
import {
  StkleService,
  StklgService,
  StkmaService,
} from '../_service_stk';
import { FilterModel, RowDoubleClickedEvent } from 'ag-grid-community';
import { MatGridListModule } from '@angular/material/grid-list';
import { StockService } from '../services/stock.service';
import { JkbbchartComponent } from '../components/jkbbchart/jkbbchart.component';
import { Stkpi19PkgComponent } from './stkpi19Pkg.component';
import { AdvComModule, JkaggridComponent } from 'jk-advcom';
import { Stktm } from '../entity/Stktm-angular';

@Component({
  selector: 'app-stkpi19',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    MatGridListModule,
    //Stkpi19DetailComponent,
    //StktmEditComponent,
    //StockKLineComponent,
    AdvComModule,
    JkbbchartComponent,
  ],
  templateUrl: './stkpi19.component.html', // ###
  styleUrls: [],
})
export class Stkpi19Component extends Stkpi19PkgComponent implements OnInit {
  //override _singleGridHeight: number = 200;
  gridSeek(value: string, fields: string) {
    let fieldList = fields.split(',');
    if (this.masterGrid)
      if (this.masterGrid.gridSrv)
        if (this.masterGrid.gridSrv.gridApi) {
          // 使用 forEachNode 遍歷所有節點

          this.masterGrid.gridSrv.gridApi.forEachNode((node) => {
            fieldList.forEach((field) => {
              if (node.data[field] === value) {
                // 假設每行資料有一個 'id' 屬性
                // 確保找到的節點在視圖中可見
                if (node.rowIndex)
                  this.masterGrid.gridSrv.gridApi.ensureIndexVisible(
                    node.rowIndex
                  );

                // （可選）選擇該節點
                node.setSelected(true);
              }
            });
          });
        }
  }
  public stkleSrv: StkleService = new StkleService();

  stockSrv: StockService = new StockService();
  stklgSrv: StklgService = new StklgService();
  stkmaSrv: StkmaService = new StkmaService();
  stockno!: string;
  barGroupWidth: number = 400;
  visualRange: any = {};
  get chartHeight(): number {
    return this.screenHeight - 40;
  }
  isGridTileVisible: boolean = false;
  //gridTileCols: number = 2;
  toggleGridTile(): void {
    this.isGridTileVisible = !this.isGridTileVisible;
    //if (this.isGridTileVisible) this.gridTileCols = 2;
    //else this.gridTileCols = 1;
  }

  constructor() {
    super();
    this.uiMode = UiModeType.dialog; //dialog,tab
    this.title = '追蹤股票建立';
  }
  override ngOnInit() {
    super.ngOnInit();
  }

  // 客製開始====================================================
  stkmaList: any[] = [];

  override async constructorInit(): Promise<void> {
    await super.constructorInit();
    // this.gridStyle ={
    //   width: '100%',
    //   height: '100%',
    //   flex: '1 1 auto',
    // };
  }
  override onBeforePost(item: Stktm, ret: jkRestReturn): void {
    super.onBeforePost(item, ret);
    this.item.TM007 = this.nowDate();
    this.item.TM025 = this.nowTime8();
  }
  /*override get gridStyle(): any {
    return {
      width: '100%',
      height: '100%',
      flex: '1 1 auto',
    };
  }*/
  /* ###
  override detailPageReady($event: any) {
    super.detailPageReady($event);
    this.detailPage.detailSrv.linkMasterFields = 'WL001=TM002';
  }*/

  //_isMonitor: boolean | null | undefined = false;
  _isMonitor: boolean = false;
  get isMonitor(): boolean {
    return this._isMonitor;
  }
  //set isMonitor(value: boolean | null | undefined) {
  set isMonitor(value: boolean) {
    this._isMonitor = value;
    this.doMonitor(value as any);
  }
  /*tm002Validation(e: any) {
    if (e.value) {
      let stkma: Stkma = this.stkmaList.find(
        (x: any) => x.MA001 === e.value
      );
      if (stkma) {
        this.item.TM003 = stkma.MA002;
        this.item.XQNO = stkma.MA028;
      }
    }
    return;
  }*/
  override async onBeforeScroll(item: any, ret: jkRestReturn) {
    if (await this.confirm('', '是否存檔?')) {
      this.srv.doUIOk(this.item); //doPost();
    }
  }
  doMonitor(isMonitor: boolean) {
    const model: FilterModel = {
      MONITOR: {
        //MONITOR 是欄位ID
        filterType: 'number',
        // https://ag-grid.com/angular-data-grid/filter-number/#number-filter-values
        type: 'greaterThan', // equals | notEqual | lessThan | lessThanOrEqual | greaterThan | greaterThanOrEqual | inRange
        filter: 1,
      },
    };
    if (!isMonitor) {
      this.masterGrid.gridApi.setFilterModel(null);
    } else {
      this.masterGrid.gridApi.setFilterModel(model);
    }
  }
  async doDeleteStkle() {
    let item = this.masterGrid.gridSrv.getFocusedRowData();
    if (item) {
      let ret = await this.stkleSrv.deleteStock(this.nowDate(), item.TM002);
      if (ret.result) {
        this.showToast('刪除成功');
      } else {
        this.showToast('刪除失敗:' + ret.message);
      }
    }
  }
  gridDoubleClick($event: RowDoubleClickedEvent<any, any>) {
    this.stockno = $event.data.TM002;
  }
  async clearMonitorPrice() {
    this.srv.doEdit();
    this.srv.doClearPrice();
    let bool = await this.srv.doMyOk();
    if (bool) {
      this.showToast('清除成功');
    } else {
      this.showAlert('清除失敗');
    }

  }
  override afterGridReady($event: JkaggridComponent): void {
    super.afterGridReady($event);
    this.masterGrid.addEditDelButton();
  }

}
